export const SET_TASK_DATA = "SET_TASK_DATA";
export const SET_TASK_PAGINATION = "SET_TASK_PAGINATION";
export const SET_TASK_FILTER = "SET_TASK_FILTER";
export const RESET_BREAK_REDUCER = "RESET_BREAK_REDUCER";
